export const IVV_STEPS = [
	'Handleiding',
	'Organisatiegegevens',
	'Projectgegevens',
	'Projectplanning',
	'Financieel plan',
	'Verklaring inzake staatssteun',
	'Verklaring op eer',
];
